import classes from './StackButton.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
}

const StackButton = ({
  children
}: Props) => (
  <div className={classes.StackButton}>
    {children}
  </div>
)

export default StackButton
